function ArticleHeader(props) {
  return <h3 className="article-header">{props.content}</h3>;
}

export default ArticleHeader;
